import { Reveal } from "@/lib/reveal";
import swimImage from "@/assets/swim-divider.jpg";

export function SwimDivider() {
  return (
    <section aria-label="Photographic interlude" data-testid="swim-divider">
      <Reveal>
        <img
          src={swimImage}
          alt="Maya, a character in The Inkwell's film At Last, underwater turned up toward the sunlit surface — a different perspective is possible"
          loading="lazy"
          width={1536}
          height={227}
          className="photo-wash w-full object-cover"
        />
      </Reveal>
    </section>
  );
}
